import IconProps from "./icon-props";

export default function MetaIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7610_1032)">
        <path d="M11.5234 9.04717C13.3219 6.07045 14.9001 4.5824 16.258 4.58301C18.2949 4.58301 19.5809 6.94984 20.3317 10.1618C21.0485 13.2308 20.8414 17.4163 18.2949 17.4163C17.16 17.4163 15.598 15.7425 14.069 13.5113C13.0939 12.0991 12.2422 10.6056 11.5234 9.04717ZM11.5234 9.04717C9.54467 6.07045 7.80881 4.5824 6.31586 4.58301C4.07461 4.58301 2.66019 6.94984 1.83336 10.1618C1.04594 13.2318 1.27511 17.4163 4.07553 17.4163C5.32403 17.4163 7.04278 15.7425 8.72303 13.5113C9.84258 12.0221 10.7761 10.534 11.5234 9.04717Z" stroke="#131834" strokeWidth="1.5675" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_7610_1032">
          <rect width="22" height="22" fill="white" transform="translate(0.523438)" />
        </clipPath>
      </defs>
    </svg>
  )
}